function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Settings'))  {
    return [
    {
      title: 'Settings',
      icon: 'mdi-cog-outline',
      items: [
        // {
        //   icon: "mdi-domain",
        //   title: "set_facilities",
        //   path: '/SetFacilities'
        // },
        // {
        //   icon: 'mdi-account',
        //   title: 'set_employees',
        //   path: '/SetEmployees'
        // },
        {
          icon: 'mdi-contacts',
          title: 'set_contacts_people',
          path: '/SetContactsPeople'
        },
        {
          icon: 'mdi-rhombus-split',
          title: 'set_clients',
          path: '/SetClients'
        },
        {
          icon: 'mdi-domain',
          title: 'set_rooms',
          path: '/SetRooms'
        },
        {
          icon: "mdi-cube-send",
          title: 'set_transport',
          path: '/SetTransport'
        },
        {
          icon: 'mdi-cannabis',
          title: 'set_strain',
          path: '/SetStrain'
        }, 
        // {
        //   icon: 'mdi-cube-scan',
        //   title: 'set_prodtype',
        //   path: '/SetProdtype'
        // },
        {
          icon: 'mdi-bank',
          title: 'set_tax',
          path: '/SetTax'
        },
        {
          icon: 'mdi-bank-transfer',
          title: 'set_relation',
          path: '/SetRelation'
        },
        // {
        //   icon: 'mdi-swap-horizontal-bold',
        //   title: 'int_customer',
        //   path: '/SetIntCustomer'
        // },
        // {
        //   icon: 'mdi-printer',
        //   title: 'set_printers',
        //   path: '/SetPrinters'
        // },
        // {
        //   icon: 'mdi-account-multiple',
        //   title: 'set_role',
        //   path: '/SetRole'
        // },
        {
          icon: 'mdi-key',
          title: 'set_mylic',
          path: '/SetMylic'
        }
        
      ]
    }
  ] } else return []
}

export default buildMenu